import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ShowDistanceComponent } from './components/show-distance/show-distance.component';
import { ShowDistancePopupComponent } from './components/show-distance-popup/show-distance-popup.component';

const routes: Routes = [
  { path: '', component: ShowDistanceComponent },
  { path: '', component: ShowDistancePopupComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ShowDistanceRoutingModule { }
